import React from "react";
import sparkles from "../assets/images/icon-sparkles.svg";
import { Link } from "react-router-dom";
const tickerItems = [
  "For any additional inquiries : brightlifephysio@gmail.com",
  "For Appointments: 090006 66889",
  "Working Hours : Mon to Sat : 10:00 AM To 8:00 PM",
];

export default function Footer() {
  return (
    <div>
   
    <div className="our-scrolling-ticker">
      <div className="scrolling-ticker-box">
        
        {/* Duplicate content twice for seamless looping */}
        {[1, 2].map((loop, index) => (
          <div className="scrolling-content" key={index}>
            {tickerItems.map((text, idx) => (
              <span key={idx}>
                <img loading="lazy" src={sparkles} alt="icon" /> {text}
              </span>
            ))}
          </div>
        ))}

      </div>
    </div>
    
    <footer className="main-footer">
      <div className="container">
        <div className="row">

          {/* Footer Navigation Links */}
          <div className="col-lg-12">
            <div className="about-service-list">
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#therapists">Therapists</a></li>
                <li><a href="#contact">Contact Us</a></li>
              </ul>
            </div>
          </div>

        </div>

        {/* Copyright Section */}
        <div className="footer-copyright">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="footer-copyright-text">
                <p>
                  Copyright © {new Date().getFullYear()} Brightlife Physio
                  Point. All Rights Reserved.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="footer-links">
                <ul>
                 <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                <li><Link to="/disclaimer">Disclaimer</Link></li>
                </ul>
              </div>
            </div>

          </div>
        </div>

      </div>
    </footer>
    </div>
  );
}
